import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGithub, faLinkedin } from '@fortawesome/free-brands-svg-icons';
import './social.css';

export default function Social() {
  const { t } = useTranslation();

  return (
    <nav 
      className='social'
      aria-label={t('aria-label.social.links')}
    >
        <a 
          href='https://www.linkedin.com/in/moe-kamimoto/'
          target='_blank'
          rel='noopener noreferrer'
          aria-label={t('aria-label.social.LinkedIn')}
        >
          <FontAwesomeIcon icon={faLinkedin} />
        </a>
        <a 
          href='https://github.com/moe-kami'
          target='_blank'
          rel='noopener noreferrer'
          aria-label={t('aria-label.social.GitHub')}
        >
          <FontAwesomeIcon icon={faGithub} />
        </a>
    </nav>
  );
}
